export const getSafeRedirect = (value) => {
  if (typeof value !== "string") return null;

  const redirect = value.trim();
  if (!redirect || redirect === "null" || redirect === "undefined") {
    return null;
  }

  // 僅允許站內路徑，避免導向外部網址或 protocol-relative URL。
  return redirect.startsWith("/") && !redirect.startsWith("//")
    ? redirect
    : null;
};
